/* label.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./label.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { B200, B300, B400, B50, N10, N100, N20, N30, N70, N80, N900, R300 } from '@atlaskit/theme/colors';
var baseStyles = null;
var textLabelLayoutStyles = null;
var disabledStyles = null;
var labelStyles = null;
export default function Label(_ref) {
  var children = _ref.children,
    isDisabled = _ref.isDisabled,
    testId = _ref.testId,
    label = _ref.label,
    id = _ref.id,
    xcss = _ref.xcss;
  return /*#__PURE__*/React.createElement("label", {
    className: ax(["_11c82smr _1e0c11p5 _1ejihkll _umai184x _syazovqm _80om73ad", label && "_zulp1te3 _yv0ey09t", isDisabled && "_syaz7wap _80om13gf", "_h5e31kd8 _1nzs1kc0 _1esz1j4g _yp0j1ehr _ay2w1ouc _d51u12ci _phftddza _1g1fe69j _l6wk1j4g _1dik1ehr _1sfg1380 _fpdj1ouc _1yjc3zdg _oaj1ddza _1j3h1380 _eawbxz7c _1rdaeh7q _18q0snw8 _13hr1j28", xcss]),
    "data-testid": testId,
    "data-disabled": isDisabled || undefined,
    id: id,
    style: {
      "--_5xk3r4": ix("var(--ds-text, ".concat(N900, ")")),
      "--_1l71759": ix("var(--ds-space-0, 0px)".concat(" ", "var(--ds-space-050, 4px)")),
      "--_1ynhf1h": ix("var(--ds-text-disabled, ".concat(N80, ")")),
      "--_4mkb4g": ix("var(--ds-background-input, ".concat(N10, ")")),
      "--_1cd0fcx": ix("var(--ds-background-input-pressed, ".concat(B50, ")")),
      "--_1gcp7nr": ix("var(--ds-background-selected-bold, ".concat(B400, ")")),
      "--_14y1fod": ix("var(--ds-background-selected-bold-hovered, ".concat(B300, ")")),
      "--_r5pknd": ix("var(--ds-background-disabled, ".concat(N20, ")")),
      "--_1z08gfx": ix("var(--ds-background-input-hovered, ".concat(N30, ")")),
      "--_vnm8xo": ix("var(--ds-border-input, ".concat(N100, ")")),
      "--_rczcge": ix("var(--ds-border, ".concat(B50, ")")),
      "--_1i4xulb": ix("var(--ds-border-danger, ".concat(R300, ")")),
      "--_xjqa3d": ix("var(--ds-border-focused, ".concat(B200, ")")),
      "--_uq1ko9": ix("var(--ds-icon-inverse, ".concat(B400, ")")),
      "--_jf353p": ix("var(--ds-icon-inverse, ".concat(N10, ")")),
      "--_1xmcmw9": ix("var(--ds-icon-disabled, ".concat(N70, ")"))
    }
  }, children);
}